import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import classNames from 'classnames';
import { ReactNode, useId } from 'react';
import { DataHTMLAttributes } from 'react';

export type PropsMenuListItem = {
  showUnderline?: boolean;
  label: string;
  icon?: ReactNode;
  isCompactMode?: boolean;
  isExpand?: boolean;
  showExpandIcon?: boolean;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
} & {
  [key: `aria-${string}`]: string;
} & DataHTMLAttributes<HTMLDivElement>;

export default function MenuListItem({
  showUnderline,
  label,
  icon,
  isCompactMode,
  isExpand,
  showExpandIcon,
  selected,
  disabled,
  className,
  onClick,
  ...restProps
}: PropsMenuListItem) {
  const ariaId = useId();
  return (
    <ListItem
      className={classNames(`mb-2`, {
        'border-vs-neut-300 border-b pb-2': showUnderline,
      })}
      disablePadding
      role="presentation"
    >
      <ListItemButton
        {...restProps}
        role="menuitem"
        className={classNames(`rounded-r-3xl`, className)}
        aria-labelledby={ariaId}
        selected={selected}
        sx={{
          minHeight: 48,
          justifyContent: !isCompactMode ? 'initial' : 'center',
          columnGap: 1,
          px: 2.5,
          paddingLeft: '24px',
          '&:hover': {
            background: '#e6eef8',
          },
          '&.selected': {
            background: '#e6eef8',
          },
        }}
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
        <ListItemText
          id={ariaId}
          className={classNames(
            'lg:block',
            !isCompactMode ? 'block' : 'hidden'
          )}
          primary={label}
          primaryTypographyProps={{
            className: 'vs-label-md-medium',
          }}
        />
        {showExpandIcon && (isExpand ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>
    </ListItem>
  );
}
